import { sortAlphabeticallyByKey } from '@fortem-monorepo/js-utilities'

export const FACTORS = [
  'AGF',
  'AMC',
  'Asset Swap',
  'Benchmark',
  'Beta',
  'Bond Carry',
  'Bond Curve',
  'Bond Volatility',
  'Carry',
  'Commodity Carry',
  'Commodity Congestion',
  'Commodity Curve',
  'Commodity Momentum',
  'Commodity Value',
  'Cross Asset Momentum',
  'DGF',
  'Equities Carry',
  'Equities Congestion',
  'Equities Liquidity',
  'Equities Momentum',
  'Equities Multi Factor',
  'Equities Size',
  'Equities Value',
  'Equities Volatility',
  'Equity',
  'Equity Multi-style',
  'Equity Volatility',
  'European Equity Vol Arb',
  'FX Carry',
  'FX Congestion',
  'Gold',
  'Growth',
  'Imbalance',
  'Liquidity',
  'Low Beta',
  'Macro',
  'Momentum',
  'Multi-Factor',
  'Property',
  'Quality',
  'Rates Carry',
  'Rates Curve',
  'Rates Multi -strat',
  'SPTR Index',
  'Size',
  'US Equity Vol Arb',
  'USD',
  'Value',
  'Volatility',
  'X Asset Volatility',
] as const

export type Factor = (typeof FACTORS)[number]

export const FACTOR_OPTIONS = sortAlphabeticallyByKey(
  FACTORS.map((a) => ({ label: a, value: a })),
  'label',
)
